import { PropsWithChildren } from "react";
import { Button, ButtonContainer } from "../button";
import classes from "./ctas.module.css";

interface CtasProps {
  classList?: Array<string>;
}

interface CtaBlockProps {
  title: string;
  img?: string;
  isLight?: boolean;
  titleClasName?: string;
  ctaItems: {
    text: string;
    link: string;
  }[];
}

const Ctas = ({ children, classList }: PropsWithChildren<CtasProps>) => {
  classList = classList || [];
  const classStrings = [classes.marketing__ctas, ...classList];

  return <section className={classStrings.join(" ")}>{children}</section>;
};

const CtaBlock = ({
  title,
  img,
  isLight,
  ctaItems,
  titleClasName,
}: CtaBlockProps) => {
  const styles = {};
  if (img) styles["backgroundImage"] = `url(${img})`;

  const classList = [classes.marketing__ctas_block];
  if (isLight) classList.push(classes.marketing__ctas_block_light);

  return (
    <div className={classList.join(" ")} style={styles}>
      <h2 className={titleClasName ?? ""}>{title}</h2>
      <ButtonContainer classList={[classes.marketing__ctas_button_container]}>
        {ctaItems.map(({ text, link }) => (
          <Button
            className={classes.marketing__ctas_button}
            buttonText={text}
            buttonHref={link}
          />
        ))}
      </ButtonContainer>
    </div>
  );
};

const BookDemoButton = ({
  href = "https://calendly.com/d/y5j-gmq-5x9/r8er-start-up-one-to-one-meeting",
  text = "Book a demo",
}: {
  href?: string;
  text?: string;
}) => (
  <Button
    style={{
      width: "30%",
      maxWidth: "535px",
      marginInline: "auto",
      display: "block",
      marginTop: "1.6rem",
      marginBottom: "1.6rem",
      textAlign: "center",
    }}
    buttonText={text}
    buttonHref={href}
  />
);

const SignUpButton = ({
  href = "/auth/signup",
  text = "Sign Up Now",
}: {
  href?: string;
  text?: string;
}) => (
  <Button
    style={{
      width: "53.5%",
      maxWidth: "535px",
      marginInline: "auto",
      display: "block",
      marginTop: "1.6rem",
      marginBottom: "1.6rem",
      textAlign: "center",
    }}
    buttonText={text}
    buttonHref={href}
  />
);

const LargeButton = ({
  href = "/auth/signup",
  text = "Sign Up Now",
}: {
  href?: string;
  text?: string;
}) => (
  <Button
    style={{
      width: "73.5%",
      maxWidth: "535px",
      marginInline: "auto",
      display: "block",
      marginTop: "1.6rem",
      marginBottom: "1.6rem",
      textAlign: "center",
    }}
    buttonText={text}
    buttonHref={href}
  />
);

export { BookDemoButton, CtaBlock, Ctas, LargeButton, SignUpButton };

